/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CreatePurchaseRequestWithFilePayload, PurchaseRequestDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPurchaseRequestCreationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-purchase-request-creation-controller
   * @name CreatePurchaseRequestWithFile
   * @request POST:/api/v1/purchase-requests
   */
  createPurchaseRequestWithFile = (
    data: CreatePurchaseRequestWithFilePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<PurchaseRequestDto, any>({
      path: `/v1/purchase-requests`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static createPurchaseRequestWithFilePath = '/v1/purchase-requests'
  static createPurchaseRequestWithFileMethod = 'POST'
}
